export enum StatusRecordStatus
    {
        Active,
        Inactive,
        Deleted,
        WIP
    };